package ru.playa.sce.dto

enum class LinkType(val displayName: String) {
    SELF("На себя"),
    OBJECT("На объект"),
    URL("URL")
}